export default {
    zh: {
        // SEO Meta
        pageTitle: 'Google Imagen 4 图像生成器 - 免费文本转图像在线',
        pageDescription: '谷歌的 Imagen 4 是一个强大的文本到图像扩散模型，旨在与 OpenAI 的 DALL-E 竞争，它可以使用简单的文本描述即时生成各种风格的图像。从照片写实到抽象意象，该 AI 模型都能提供细节丰富的输出。在 WeryAI 图像生成器上免费试用 Imagen 4！',
        pageKeywords: 'Imagen, Imagen 4, Google AI, AI 图像生成, AI 绘画, 人工智能, 图像编辑, 创意表达, 文本转图像',

        // Open Graph
        ogTitle: 'Google Imagen 4 图像生成器 - 免费文本转图像在线',
        ogDescription: '体验 Google Imagen 4 图像生成器，谷歌开发的强大的文本到图像扩散模型。',

        // Twitter Card
        twitterTitle: 'Google Imagen 4 图像生成器 - 免费文本转图像在线',
        twitterDescription: '体验 Google Imagen 4 图像生成器，谷歌开发的强大的文本到图像扩散模型。',

        // Generator Section
        generatorTitle: 'Google Imagen 4 图像生成器',
        generatorSubtitle: 'WeryAI 现已深度集成Imagen模型，旨在与 OpenAI 的 DALL-E 竞争，它可以使用简单的文本描述即时生成各种风格的图像。从照片写实到抽象意象，该 AI 模型都能提供细节丰富的输出。在 WeryAI 图像生成器上免费试用 Imagen 4！',

        // Core Features Section
        coreFeaturesTitle: 'Imagen 核心功能特性',
        coreFeaturesSubtitle: '探索 Google Imagen 4 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // Features
        accurateTextToImageTitle: '准确的文本到图像生成',
        accurateTextToImageDesc: '使用描述性文字提示生成高质量的图像。',
        accurateTextToImageAlt: '准确的文本到图像生成示例',

        advancedTextRenderingTitle: '高级文本渲染',
        advancedTextRenderingDesc: '强大的文本提示分析和遵循。',
        advancedTextRenderingAlt: '高级文本渲染示例',

        diverseArtisticStylesTitle: '多样的艺术风格',
        diverseArtisticStylesDesc: '以创造性的天赋创造各种主题和风格。',
        diverseArtisticStylesAlt: '多样的艺术风格示例',

        // How to Use Section
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 Imagen 模型',

        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube Videos Section
        youtubeTitle: '关于 Imagen 4 图像模型的 YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 Imagen 4 图像模型的 X 帖子',

        // Explore Other Models Section
        exploreModelsTitle: '在 WeryAI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ Section
        faqTitle: '常见问题解答',

        faq1Question: '什么是 Google Imagen 4?',
        faq1Answer: '谷歌的 Imagen 4 是一个强大的文本到图像扩散模型，旨在与 OpenAI 的 DALL-E 竞争，它可以使用简单的文本描述即时生成各种风格的图像。从照片写实到抽象意象，该 AI 模型都能提供细节丰富的输出。',

        faq2Question: 'Imagen 与其他图像生成模型相比有哪些优势?',
        faq2Answer: 'Imagen 在图像质量、创意表达、风格控制和多模态融合方面具有显著优势。它能够生成高质量的专业级图像，并支持复杂的创意表达。',

        faq3Question: '我能免费使用 Google Imagen 4 吗?',
        faq3Answer: '是的。Google Imagen 4 通过 WeryAI 的免费试用提供有限的免费额度。如需大量使用,则需要升级。',

        faq4Question: 'Imagen 支持哪些图像格式?',
        faq4Answer: 'Imagen 支持多种图像格式，包括 JPG、PNG、WEBP 等常见格式。生成的图像具有高质量和丰富的细节表现。',

        faq5Question: '我可以使用 Imagen 用于商业项目吗?',
        faq5Answer: '是的。Imagen 的高精度图像生成和创意表达能力使其成为设计师、艺术家和内容创作者寻求高质量 AI 生成图像的有力选择。',

        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Imagen 4，将您的创意转化为精彩图像',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    en: {
        // SEO Meta
        pageTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        pageDescription: 'Google Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI DALL-E. Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        ogDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Twitter Card
        twitterTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        twitterDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Generator Section
        generatorTitle: 'Google Imagen 4 Image Generator',
        generatorSubtitle: 'WeryAI now deeply integrates the Imagen model, Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',

        // Core Features Section
        coreFeaturesTitle: 'Imagen Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Google Imagen 4 image generator and embark on a revolutionary AI image creation journey',

        // Features
        accurateTextToImageTitle: 'Accurate Text-to-Image Generation',
        accurateTextToImageDesc: 'Generate high-quality images using descriptive text prompts.',
        accurateTextToImageAlt: 'Accurate Text-to-Image Generation Example',

        advancedTextRenderingTitle: 'Advanced Text Rendering',
        advancedTextRenderingDesc: 'Powerful text prompt analysis and following.',
        advancedTextRenderingAlt: 'Advanced Text Rendering Example',

        diverseArtisticStylesTitle: 'Diverse Artistic Styles',
        diverseArtisticStylesDesc: 'Create various themes and styles with creative flair.',
        diverseArtisticStylesAlt: 'Diverse Artistic Styles Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Imagen model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Imagen 4 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Imagen 4 Image Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Imagen 4?',
        faq1Answer: 'Google\'s Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI\'s DALL-E. It can generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs.',

        faq2Question: 'What advantages does Imagen have over other image generation models?',
        faq2Answer: 'Imagen has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',

        faq3Question: 'Can I use Google Imagen 4 for free?',
        faq3Answer: 'Yes. Google Imagen 4 offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',

        faq4Question: 'What image formats does Imagen support?',
        faq4Answer: 'Imagen supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Imagen for commercial projects?',
        faq5Answer: 'Yes. Imagen\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Imagen 4 now and transform your ideas into amazing images',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    ja: {
        // 日语翻译
        pageTitle: 'Google Imagen 4 AI画像ジェネレーター - 無料のテキストから画像へ',
        pageDescription: 'Google Imagen 4は、OpenAI DALL-Eと競合するように設計された強力なテキストから画像への拡散モデルです。簡単なテキスト説明から様々なスタイルの画像を生成します。写実的なものから抽象的なものまで、このAIモデルは詳細な出力を提供します。WeryAIでImagen 4を無料でお試しください！',
        pageKeywords: 'Imagen 4, Google AI, AI画像生成, AIアート, 人工知能, 画像編集, クリエイティブ表現, テキストから画像',
        ogTitle: 'Google Imagen 4 AI画像ジェネレーター - 無料のテキストから画像へ',
        ogDescription: 'Googleが開発した強力なテキストから画像への拡散モデル、Google Imagen 4画像ジェネレーターを体験してください。',
        twitterTitle: 'Google Imagen 4 AI画像ジェネレーター - 無料のテキストから画像へ',
        twitterDescription: 'Googleが開発した強力なテキストから画像への拡散モデル、Google Imagen 4画像ジェネレーターを体験してください。',
        generatorTitle: 'Google Imagen 4画像ジェネレーター',
        generatorSubtitle: 'WeryAI はImagenモデルを深く統合し、簡単なテキスト説明から様々なスタイルの画像を生成します。写実的なものから抽象的なものまで、このAIモデルは詳細な出力を提供します。WeryAIでImagen 4を無料でお試しください！',
        coreFeaturesTitle: 'Imagenの主な機能',
        coreFeaturesSubtitle: 'Google Imagen 4画像ジェネレーターの主な機能を探索し、革新的なAI画像作成の旅に出ましょう',
        accurateTextToImageTitle: '正確なテキストから画像への生成',
        accurateTextToImageDesc: '説明的なテキストプロンプトを使用して高品質な画像を生成します。',
        accurateTextToImageAlt: '正確なテキストから画像への生成の例',
        advancedTextRenderingTitle: '高度なテキストレンダリング',
        advancedTextRenderingDesc: '強力なテキストプロンプト分析とフォローイング。',
        advancedTextRenderingAlt: '高度なテキストレンダリングの例',
        diverseArtisticStylesTitle: '多様な芸術スタイル',
        diverseArtisticStylesDesc: 'クリエイティブな才能で様々なテーマとスタイルを作成します。',
        diverseArtisticStylesAlt: '多様な芸術スタイルの例',
        howToUseTitle: '使い方',
        howToUseSubtitle: '簡単3ステップで開始',
        step1Title: 'モデルを選択',
        step1Description: 'AI画像ツールでImagenモデルを選択',
        step2Title: 'コンテンツを入力',
        step2Description: 'プロンプトを入力または参照画像をアップロード',
        step3Title: '画像を生成',
        step3Description: '生成ボタンをクリックし、待機して画像をダウンロード',
        youtubeTitle: 'Imagen 4画像モデルについてのYouTube動画',
        xPostsTitle: 'Imagen 4画像モデルについてのX投稿',
        exploreModelsTitle: 'WeryAIで他のAI画像モデルを探索',
        model1Title: 'Google Nano Banana AI画像ジェネレーター',
        model2Title: 'FLUX AI画像ジェネレーター',
        model3Title: 'Qwen Image AI画像ジェネレーター',
        faqTitle: 'よくある質問',
        faq1Question: 'Google Imagen 4とは何ですか？',
        faq1Answer: 'GoogleのImagen 4は、OpenAIのDALL-Eと競合するように設計された強力なテキストから画像への拡散モデルです。簡単なテキスト説明から様々なスタイルの画像を生成できます。写実的なものから抽象的なものまで、このAIモデルは詳細な出力を提供します。',
        faq2Question: 'Imagenは他の画像生成モデルと比べてどのような利点がありますか？',
        faq2Answer: 'Imagenは、画像品質、クリエイティブ表現、スタイルコントロール、マルチモーダル融合において大きな利点があります。高品質なプロフェッショナルグレードの画像を生成でき、複雑なクリエイティブ表現をサポートします。',
        faq3Question: 'Google Imagen 4を無料で使用できますか？',
        faq3Answer: 'はい。Google Imagen 4はWeryAIの無料トライアルを通じて限定的な無料クレジットを提供しています。大量使用の場合はアップグレードが必要です。',
        faq4Question: 'Imagenはどのような画像形式をサポートしていますか？',
        faq4Answer: 'ImagenはJPG、PNG、WEBPなどの一般的な形式を含む様々な画像形式をサポートしています。生成された画像は高品質で豊富な詳細を特徴としています。',
        faq5Question: 'Imagenを商業プロジェクトに使用できますか？',
        faq5Answer: 'はい。Imagenの高精度画像生成とクリエイティブ表現機能は、高品質なAI生成画像を求めるデザイナー、アーティスト、コンテンツクリエーターにとって強力な選択肢となります。',
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription: '今すぐImagen 4を体験し、あなたのアイデアを素晴らしい画像に変換',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    ko: {
        // 韩语翻译
        pageTitle: 'Google Imagen 4 AI 이미지 생성기 - 무료 텍스트에서 이미지로',
        pageDescription: 'Google Imagen 4는 OpenAI DALL-E와 경쟁하도록 설계된 강력한 텍스트에서 이미지 확산 모델입니다. 간단한 텍스트 설명으로 다양한 스타일의 이미지를 생성합니다. 사진 사실적인 것부터 추상적인 것까지, 이 AI 모델은 상세한 출력을 제공합니다. WeryAI에서 무료로 Imagen 4를 체험하세요!',
        pageKeywords: 'Imagen 4, Google AI, AI 이미지 생성, AI 아트, 인공지능, 이미지 편집, 창의적 표현, 텍스트에서 이미지',
        ogTitle: 'Google Imagen 4 AI 이미지 생성기 - 무료 텍스트에서 이미지로',
        ogDescription: 'Google에서 개발한 강력한 텍스트에서 이미지 확산 모델인 Google Imagen 4 이미지 생성기를 체험하세요.',
        twitterTitle: 'Google Imagen 4 AI 이미지 생성기 - 무료 텍스트에서 이미지로',
        twitterDescription: 'Google에서 개발한 강력한 텍스트에서 이미지 확산 모델인 Google Imagen 4 이미지 생성기를 체험하세요.',
        generatorTitle: 'Google Imagen 4 이미지 생성기',
        generatorSubtitle: 'WeryAI는 이제 Imagen 모델을 심층 통합하여, 간단한 텍스트 설명으로 다양한 스타일의 이미지를 생성합니다. 사진 사실적인 것부터 추상적인 것까지, 이 AI 모델은 상세한 출력을 제공합니다. WeryAI에서 무료로 Imagen 4를 체험하세요!',
        coreFeaturesTitle: 'Imagen의 주요 기능',
        coreFeaturesSubtitle: 'Google Imagen 4 이미지 생성기의 주요 기능을 탐색하고 혁신적인 AI 이미지 제작 여정을 시작하세요',
        accurateTextToImageTitle: '정확한 텍스트에서 이미지 생성',
        accurateTextToImageDesc: '설명적인 텍스트 프롬프트를 사용하여 고품질 이미지를 생성합니다.',
        accurateTextToImageAlt: '정확한 텍스트에서 이미지 생성 예시',
        advancedTextRenderingTitle: '고급 텍스트 렌더링',
        advancedTextRenderingDesc: '강력한 텍스트 프롬프트 분석 및 추종.',
        advancedTextRenderingAlt: '고급 텍스트 렌더링 예시',
        diverseArtisticStylesTitle: '다양한 예술 스타일',
        diverseArtisticStylesDesc: '창의적인 재능으로 다양한 테마와 스타일을 만듭니다.',
        diverseArtisticStylesAlt: '다양한 예술 스타일 예시',
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        step1Title: '모델 선택',
        step1Description: 'AI 이미지 도구에서 Imagen 모델 선택',
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '이미지 생성',
        step3Description: '생성 버튼 클릭, 대기 후 이미지 다운로드',
        youtubeTitle: 'Imagen 4 이미지 모델에 대한 YouTube 비디오',
        xPostsTitle: 'Imagen 4 이미지 모델에 대한 X 게시물',
        exploreModelsTitle: 'WeryAI에서 다른 AI 이미지 모델 탐색',
        model1Title: 'Google Nano Banana AI 이미지 생성기',
        model2Title: 'FLUX AI 이미지 생성기',
        model3Title: 'Qwen Image AI 이미지 생성기',
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Google Imagen 4가 무엇인가요?',
        faq1Answer: 'Google의 Imagen 4는 OpenAI의 DALL-E와 경쟁하도록 설계된 강력한 텍스트에서 이미지 확산 모델입니다. 간단한 텍스트 설명으로 다양한 스타일의 이미지를 생성할 수 있습니다. 사진 사실적인 것부터 추상적인 것까지, 이 AI 모델은 상세한 출력을 제공합니다.',
        faq2Question: 'Imagen은 다른 이미지 생성 모델에 비해 어떤 장점이 있나요?',
        faq2Answer: 'Imagen은 이미지 품질, 창의적 표현, 스타일 제어, 멀티모달 융합에서 큰 장점이 있습니다. 고품질의 전문가급 이미지를 생성할 수 있으며 복잡한 창의적 표현을 지원합니다.',
        faq3Question: 'Google Imagen 4를 무료로 사용할 수 있나요?',
        faq3Answer: '네. Google Imagen 4는 WeryAI의 무료 체험을 통해 제한된 무료 크레딧을 제공합니다. 광범위한 사용을 위해서는 업그레이드가 필요합니다.',
        faq4Question: 'Imagen은 어떤 이미지 형식을 지원하나요?',
        faq4Answer: 'Imagen은 JPG, PNG, WEBP 등 일반적인 형식을 포함한 다양한 이미지 형식을 지원합니다. 생성된 이미지는 고품질과 풍부한 디테일을 특징으로 합니다.',
        faq5Question: 'Imagen을 상업 프로젝트에 사용할 수 있나요?',
        faq5Answer: '네. Imagen의 고정밀 이미지 생성과 창의적 표현 기능은 고품질 AI 생성 이미지를 찾는 디자이너, 아티스트, 콘텐츠 크리에이터에게 강력한 선택이 됩니다.',
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription: '지금 Imagen 4를 체험하고 당신의 아이디어를 놀라운 이미지로 변환하세요',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    tw: {

        // SEO Meta
        pageTitle: 'Google Imagen 4 图像生成器 - 免费文本转图像在线',
        pageDescription: '谷歌的 Imagen 4 是一个强大的文本到图像扩散模型，旨在与 OpenAI 的 DALL-E 竞争，它可以使用简单的文本描述即时生成各种风格的图像。从照片写实到抽象意象，该 AI 模型都能提供细节丰富的输出。在 WeryAI 图像生成器上免费试用 Imagen 4！',
        pageKeywords: 'Imagen, Imagen 4, Google AI, AI 图像生成, AI 绘画, 人工智能, 图像编辑, 创意表达, 文本转图像',

        // Open Graph
        ogTitle: 'Google Imagen 4 图像生成器 - 免费文本转图像在线',
        ogDescription: '体验 Google Imagen 4 图像生成器，谷歌开发的强大的文本到图像扩散模型。',

        // Twitter Card
        twitterTitle: 'Google Imagen 4 图像生成器 - 免费文本转图像在线',
        twitterDescription: '体验 Google Imagen 4 图像生成器，谷歌开发的强大的文本到图像扩散模型。',

        // Generator Section
        generatorTitle: 'Google Imagen 4 图像生成器',
        generatorSubtitle: 'WeryAI 現已深度整合Imagen模型，旨在与 OpenAI 的 DALL-E 竞争，它可以使用简单的文本描述即时生成各种风格的图像。从照片写实到抽象意象，该 AI 模型都能提供细节丰富的输出。在 WeryAI 图像生成器上免费试用 Imagen 4！',

        // Core Features Section
        coreFeaturesTitle: 'Imagen 核心功能特性',
        coreFeaturesSubtitle: '探索 Google Imagen 4 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // Features
        accurateTextToImageTitle: '准确的文本到图像生成',
        accurateTextToImageDesc: '使用描述性文字提示生成高质量的图像。',
        accurateTextToImageAlt: '准确的文本到图像生成示例',

        advancedTextRenderingTitle: '高级文本渲染',
        advancedTextRenderingDesc: '强大的文本提示分析和遵循。',
        advancedTextRenderingAlt: '高级文本渲染示例',

        diverseArtisticStylesTitle: '多样的艺术风格',
        diverseArtisticStylesDesc: '以创造性的天赋创造各种主题和风格。',
        diverseArtisticStylesAlt: '多样的艺术风格示例',

        // How to Use Section
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 Imagen 模型',

        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube Videos Section
        youtubeTitle: '关于 Imagen 4 图像模型的 YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 Imagen 4 图像模型的 X 帖子',

        // Explore Other Models Section
        exploreModelsTitle: '在 WeryAI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ Section
        faqTitle: '常见问题解答',

        faq1Question: '什么是 Google Imagen 4?',
        faq1Answer: '谷歌的 Imagen 4 是一个强大的文本到图像扩散模型，旨在与 OpenAI 的 DALL-E 竞争，它可以使用简单的文本描述即时生成各种风格的图像。从照片写实到抽象意象，该 AI 模型都能提供细节丰富的输出。',

        faq2Question: 'Imagen 与其他图像生成模型相比有哪些优势?',
        faq2Answer: 'Imagen 在图像质量、创意表达、风格控制和多模态融合方面具有显著优势。它能够生成高质量的专业级图像，并支持复杂的创意表达。',

        faq3Question: '我能免费使用 Google Imagen 4 吗?',
        faq3Answer: '是的。Google Imagen 4 通过 WeryAI 的免费试用提供有限的免费额度。如需大量使用,则需要升级。',

        faq4Question: 'Imagen 支持哪些图像格式?',
        faq4Answer: 'Imagen 支持多种图像格式，包括 JPG、PNG、WEBP 等常见格式。生成的图像具有高质量和丰富的细节表现。',

        faq5Question: '我可以使用 Imagen 用于商业项目吗?',
        faq5Answer: '是的。Imagen 的高精度图像生成和创意表达能力使其成为设计师、艺术家和内容创作者寻求高质量 AI 生成图像的有力选择。',

        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Imagen 4，将您的创意转化为精彩图像',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    pl: {

        // SEO Meta
        pageTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        pageDescription: 'Google Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI DALL-E. Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        ogDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Twitter Card
        twitterTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        twitterDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Generator Section
        generatorTitle: 'Google Imagen 4 Image Generator',
        generatorSubtitle: 'WeryAI jest teraz głęboko zintegrowane z modelem Imagen, Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',

        // Core Features Section
        coreFeaturesTitle: 'Imagen Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Google Imagen 4 image generator and embark on a revolutionary AI image creation journey',

        // Features
        accurateTextToImageTitle: 'Accurate Text-to-Image Generation',
        accurateTextToImageDesc: 'Generate high-quality images using descriptive text prompts.',
        accurateTextToImageAlt: 'Accurate Text-to-Image Generation Example',

        advancedTextRenderingTitle: 'Advanced Text Rendering',
        advancedTextRenderingDesc: 'Powerful text prompt analysis and following.',
        advancedTextRenderingAlt: 'Advanced Text Rendering Example',

        diverseArtisticStylesTitle: 'Diverse Artistic Styles',
        diverseArtisticStylesDesc: 'Create various themes and styles with creative flair.',
        diverseArtisticStylesAlt: 'Diverse Artistic Styles Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Imagen model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Imagen 4 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Imagen 4 Image Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Imagen 4?',
        faq1Answer: 'Google\'s Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI\'s DALL-E. It can generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs.',

        faq2Question: 'What advantages does Imagen have over other image generation models?',
        faq2Answer: 'Imagen has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',

        faq3Question: 'Can I use Google Imagen 4 for free?',
        faq3Answer: 'Yes. Google Imagen 4 offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',

        faq4Question: 'What image formats does Imagen support?',
        faq4Answer: 'Imagen supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Imagen for commercial projects?',
        faq5Answer: 'Yes. Imagen\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Imagen 4 now and transform your ideas into amazing images',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    es: {
        // Español
        pageTitle: 'Generador de Imágenes AI Google Imagen 4 - Texto a Imagen Gratis',
        pageDescription: 'Google Imagen 4 es un potente modelo de difusión de texto a imagen diseñado para competir con DALL-E de OpenAI. Genera imágenes en varios estilos a partir de descripciones de texto simples. Desde fotorrealista hasta abstracto, este modelo AI ofrece resultados detallados. ¡Prueba Imagen 4 gratis en WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, generación de imágenes AI, arte AI, inteligencia artificial, edición de imágenes, expresión creativa, texto a imagen',
        ogTitle: 'Generador de Imágenes AI Google Imagen 4 - Texto a Imagen Gratis',
        ogDescription: 'Experimenta el generador de imágenes Google Imagen 4, un potente modelo de difusión de texto a imagen desarrollado por Google.',
        twitterTitle: 'Generador de Imágenes AI Google Imagen 4 - Texto a Imagen Gratis',
        twitterDescription: 'Experimenta el generador de imágenes Google Imagen 4, un potente modelo de difusión de texto a imagen desarrollado por Google.',
        generatorTitle: 'Generador de Imágenes Google Imagen 4',
        generatorSubtitle: 'WeryAI ahora integra profundamente el modelo Imagen, Imagen 4 de Google es un potente modelo de difusión de texto a imagen diseñado para competir con DALL-E de OpenAI. Genera imágenes en varios estilos a partir de descripciones de texto simples. Desde fotorrealista hasta abstracto, este modelo AI ofrece resultados detallados. ¡Prueba Imagen 4 gratis en WeryAI!',
        coreFeaturesTitle: 'Características Principales de Imagen',
        coreFeaturesSubtitle: 'Explora las características principales del generador de imágenes Google Imagen 4 y embarca en un viaje revolucionario de creación de imágenes AI',
        accurateTextToImageTitle: 'Generación Precisa de Texto a Imagen',
        accurateTextToImageDesc: 'Genera imágenes de alta calidad usando prompts de texto descriptivos.',
        accurateTextToImageAlt: 'Ejemplo de Generación Precisa de Texto a Imagen',
        advancedTextRenderingTitle: 'Renderizado de Texto Avanzado',
        advancedTextRenderingDesc: 'Potente análisis y seguimiento de prompts de texto.',
        advancedTextRenderingAlt: 'Ejemplo de Renderizado de Texto Avanzado',
        diverseArtisticStylesTitle: 'Estilos Artísticos Diversos',
        diverseArtisticStylesDesc: 'Crea varios temas y estilos con talento creativo.',
        diverseArtisticStylesAlt: 'Ejemplo de Estilos Artísticos Diversos',
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres pasos simples para comenzar a crear',
        step1Title: 'Seleccionar Modelo',
        step1Description: 'Elige el modelo Imagen en herramientas de imagen AI',
        step2Title: 'Ingresar Contenido',
        step2Description: 'Ingresa prompts o sube imágenes de referencia',
        step3Title: 'Generar Imagen',
        step3Description: 'Haz clic en el botón generar, espera y descarga tu imagen',
        youtubeTitle: 'Videos de YouTube Sobre el Modelo de Imagen Imagen 4',
        xPostsTitle: 'Publicaciones X Sobre el Modelo de Imagen Imagen 4',
        exploreModelsTitle: 'Explora Otros Modelos de Imagen AI en WeryAI',
        model1Title: 'Generador de Imágenes AI Google Nano Banana',
        model2Title: 'Generador de Imágenes AI FLUX',
        model3Title: 'Generador de Imágenes AI Qwen Image',
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '¿Qué es Google Imagen 4?',
        faq1Answer: 'Imagen 4 de Google es un potente modelo de difusión de texto a imagen diseñado para competir con DALL-E de OpenAI. Puede generar imágenes en varios estilos a partir de descripciones de texto simples. Desde fotorrealista hasta abstracto, este modelo AI ofrece resultados detallados.',
        faq2Question: '¿Qué ventajas tiene Imagen sobre otros modelos de generación de imágenes?',
        faq2Answer: 'Imagen tiene ventajas significativas en calidad de imagen, expresión creativa, control de estilo y fusión multimodal. Puede generar imágenes de grado profesional de alta calidad y soporta expresión creativa compleja.',
        faq3Question: '¿Puedo usar Google Imagen 4 gratis?',
        faq3Answer: 'Sí. Google Imagen 4 ofrece créditos gratuitos limitados a través de la prueba gratuita de WeryAI. Para uso extensivo, se requiere una actualización.',
        faq4Question: '¿Qué formatos de imagen soporta Imagen?',
        faq4Answer: 'Imagen soporta varios formatos de imagen incluyendo JPG, PNG, WEBP y otros formatos comunes. Las imágenes generadas presentan alta calidad y detalles ricos.',
        faq5Question: '¿Puedo usar Imagen para proyectos comerciales?',
        faq5Answer: 'Sí. Las capacidades de generación de imágenes de alta precisión y expresión creativa de Imagen lo convierten en una opción poderosa para diseñadores, artistas y creadores de contenido que buscan imágenes generadas por AI de alta calidad.',
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription: 'Experimenta Imagen 4 ahora y transforma tus ideas en imágenes asombrosas',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    fr: {
        // Français
        pageTitle: 'Générateur d\'Images IA Google Imagen 4 - Texte vers Image Gratuit',
        pageDescription: 'Google Imagen 4 est un puissant modèle de diffusion de texte vers image conçu pour concurrencer DALL-E d\'OpenAI. Générez des images dans divers styles à partir de simples descriptions textuelles. Du photoréaliste à l\'abstrait, ce modèle IA fournit des résultats détaillés. Essayez Imagen 4 gratuitement sur WeryAI !',
        pageKeywords: 'Imagen 4, Google AI, génération d\'images IA, art IA, intelligence artificielle, édition d\'images, expression créative, texte vers image',
        ogTitle: 'Générateur d\'Images IA Google Imagen 4 - Texte vers Image Gratuit',
        ogDescription: 'Découvrez le générateur d\'images Google Imagen 4, un puissant modèle de diffusion de texte vers image développé par Google.',
        twitterTitle: 'Générateur d\'Images IA Google Imagen 4 - Texte vers Image Gratuit',
        twitterDescription: 'Découvrez le générateur d\'images Google Imagen 4, un puissant modèle de diffusion de texte vers image développé par Google.',
        generatorTitle: 'Générateur d\'Images Google Imagen 4',
        generatorSubtitle: 'WeryAI intègre désormais en profondeur le modèle Imagen, Imagen 4 de Google est un puissant modèle de diffusion de texte vers image conçu pour concurrencer DALL-E d\'OpenAI. Générez des images dans divers styles à partir de simples descriptions textuelles. Du photoréaliste à l\'abstrait, ce modèle IA fournit des résultats détaillés. Essayez Imagen 4 gratuitement sur WeryAI !',
        coreFeaturesTitle: 'Caractéristiques Principales d\'Imagen',
        coreFeaturesSubtitle: 'Explorez les caractéristiques principales du générateur d\'images Google Imagen 4 et embarquez dans un voyage révolutionnaire de création d\'images IA',
        accurateTextToImageTitle: 'Génération Précise de Texte vers Image',
        accurateTextToImageDesc: 'Générez des images de haute qualité en utilisant des prompts de texte descriptifs.',
        accurateTextToImageAlt: 'Exemple de Génération Précise de Texte vers Image',
        advancedTextRenderingTitle: 'Rendu de Texte Avancé',
        advancedTextRenderingDesc: 'Analyse et suivi puissants des prompts de texte.',
        advancedTextRenderingAlt: 'Exemple de Rendu de Texte Avancé',
        diverseArtisticStylesTitle: 'Styles Artistiques Divers',
        diverseArtisticStylesDesc: 'Créez divers thèmes et styles avec un flair créatif.',
        diverseArtisticStylesAlt: 'Exemple de Styles Artistiques Divers',
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer à créer',
        step1Title: 'Sélectionner le Modèle',
        step1Description: 'Choisissez le modèle Imagen dans les outils d\'image IA',
        step2Title: 'Saisir le Contenu',
        step2Description: 'Entrez des prompts ou téléchargez des images de référence',
        step3Title: 'Générer l\'Image',
        step3Description: 'Cliquez sur le bouton générer, attendez et téléchargez votre image',
        youtubeTitle: 'Vidéos YouTube Sur le Modèle d\'Image Imagen 4',
        xPostsTitle: 'Publications X Sur le Modèle d\'Image Imagen 4',
        exploreModelsTitle: 'Explorez d\'Autres Modèles d\'Image IA sur WeryAI',
        model1Title: 'Générateur d\'Images IA Google Nano Banana',
        model2Title: 'Générateur d\'Images IA FLUX',
        model3Title: 'Générateur d\'Images IA Qwen Image',
        faqTitle: 'Questions Fréquemment Posées',
        faq1Question: 'Qu\'est-ce que Google Imagen 4 ?',
        faq1Answer: 'Imagen 4 de Google est un puissant modèle de diffusion de texte vers image conçu pour concurrencer DALL-E d\'OpenAI. Il peut générer des images dans divers styles à partir de simples descriptions textuelles. Du photoréaliste à l\'abstrait, ce modèle IA fournit des résultats détaillés.',
        faq2Question: 'Quels avantages Imagen a-t-il par rapport aux autres modèles de génération d\'images ?',
        faq2Answer: 'Imagen présente des avantages significatifs en matière de qualité d\'image, d\'expression créative, de contrôle de style et de fusion multimodale. Il peut générer des images de qualité professionnelle de haute qualité et prend en charge une expression créative complexe.',
        faq3Question: 'Puis-je utiliser Google Imagen 4 gratuitement ?',
        faq3Answer: 'Oui. Google Imagen 4 offre des crédits gratuits limités via l\'essai gratuit de WeryAI. Pour une utilisation intensive, une mise à niveau est requise.',
        faq4Question: 'Quels formats d\'image Imagen prend-il en charge ?',
        faq4Answer: 'Imagen prend en charge divers formats d\'image, notamment JPG, PNG, WEBP et d\'autres formats courants. Les images générées présentent une haute qualité et des détails riches.',
        faq5Question: 'Puis-je utiliser Imagen pour des projets commerciaux ?',
        faq5Answer: 'Oui. Les capacités de génération d\'images haute précision et d\'expression créative d\'Imagen en font un choix puissant pour les designers, artistes et créateurs de contenu recherchant des images générées par IA de haute qualité.',
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription: 'Découvrez Imagen 4 maintenant et transformez vos idées en images incroyables',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    de: {
        // Deutsch
        pageTitle: 'Google Imagen 4 KI-Bildgenerator - Kostenlos Text zu Bild',
        pageDescription: 'Google Imagen 4 ist ein leistungsstarkes Text-zu-Bild-Diffusionsmodell, das entwickelt wurde, um mit OpenAI DALL-E zu konkurrieren. Generieren Sie Bilder in verschiedenen Stilen aus einfachen Textbeschreibungen. Von fotorealistisch bis abstrakt liefert dieses KI-Modell detaillierte Ergebnisse. Probieren Sie Imagen 4 kostenlos auf WeryAI aus!',
        pageKeywords: 'Imagen 4, Google AI, KI-Bildgenerierung, KI-Kunst, künstliche Intelligenz, Bildbearbeitung, kreativer Ausdruck, Text zu Bild',
        ogTitle: 'Google Imagen 4 KI-Bildgenerator - Kostenlos Text zu Bild',
        ogDescription: 'Erleben Sie den Google Imagen 4 Bildgenerator, ein leistungsstarkes Text-zu-Bild-Diffusionsmodell entwickelt von Google.',
        twitterTitle: 'Google Imagen 4 KI-Bildgenerator - Kostenlos Text zu Bild',
        twitterDescription: 'Erleben Sie den Google Imagen 4 Bildgenerator, ein leistungsstarkes Text-zu-Bild-Diffusionsmodell entwickelt von Google.',
        generatorTitle: 'Google Imagen 4 Bildgenerator',
        generatorSubtitle: 'WeryAI integriert jetzt das Modell Imagen tiefgreifend, das entwickelt wurde, um mit OpenAIs DALL-E zu konkurrieren. Generieren Sie Bilder in verschiedenen Stilen aus einfachen Textbeschreibungen. Von fotorealistisch bis abstrakt liefert dieses KI-Modell detaillierte Ergebnisse. Probieren Sie Imagen 4 kostenlos auf WeryAI aus!',
        coreFeaturesTitle: 'Imagen Kernfunktionen',
        coreFeaturesSubtitle: 'Entdecken Sie die Kernfunktionen des Google Imagen 4 Bildgenerators und begeben Sie sich auf eine revolutionäre KI-Bilderstellungsreise',
        accurateTextToImageTitle: 'Präzise Text-zu-Bild-Generierung',
        accurateTextToImageDesc: 'Generieren Sie hochwertige Bilder mit beschreibenden Text-Prompts.',
        accurateTextToImageAlt: 'Beispiel für Präzise Text-zu-Bild-Generierung',
        advancedTextRenderingTitle: 'Erweiterte Textdarstellung',
        advancedTextRenderingDesc: 'Leistungsstarke Text-Prompt-Analyse und -Befolgung.',
        advancedTextRenderingAlt: 'Beispiel für Erweiterte Textdarstellung',
        diverseArtisticStylesTitle: 'Vielfältige Künstlerische Stile',
        diverseArtisticStylesDesc: 'Erstellen Sie verschiedene Themen und Stile mit kreativem Flair.',
        diverseArtisticStylesAlt: 'Beispiel für Vielfältige Künstlerische Stile',
        howToUseTitle: 'Wie zu Verwenden',
        howToUseSubtitle: 'Drei einfache Schritte zum Erstellen',
        step1Title: 'Modell Auswählen',
        step1Description: 'Wählen Sie das Imagen-Modell in KI-Bildtools',
        step2Title: 'Inhalt Eingeben',
        step2Description: 'Geben Sie Prompts ein oder laden Sie Referenzbilder hoch',
        step3Title: 'Bild Generieren',
        step3Description: 'Klicken Sie auf die Generieren-Schaltfläche, warten Sie und laden Sie Ihr Bild herunter',
        youtubeTitle: 'YouTube-Videos Über das Imagen 4 Bildmodell',
        xPostsTitle: 'X-Beiträge Über das Imagen 4 Bildmodell',
        exploreModelsTitle: 'Entdecken Sie Andere KI-Bildmodelle auf WeryAI',
        model1Title: 'Google Nano Banana KI-Bildgenerator',
        model2Title: 'FLUX KI-Bildgenerator',
        model3Title: 'Qwen Image KI-Bildgenerator',
        faqTitle: 'Häufig Gestellte Fragen',
        faq1Question: 'Was ist Google Imagen 4?',
        faq1Answer: 'Googles Imagen 4 ist ein leistungsstarkes Text-zu-Bild-Diffusionsmodell, das entwickelt wurde, um mit OpenAIs DALL-E zu konkurrieren. Es kann Bilder in verschiedenen Stilen aus einfachen Textbeschreibungen generieren. Von fotorealistisch bis abstrakt liefert dieses KI-Modell detaillierte Ergebnisse.',
        faq2Question: 'Welche Vorteile hat Imagen gegenüber anderen Bildgenerierungsmodellen?',
        faq2Answer: 'Imagen hat bedeutende Vorteile in Bildqualität, kreativem Ausdruck, Stilkontrolle und multimodaler Fusion. Es kann hochwertige professionelle Bilder generieren und unterstützt komplexe kreative Ausdrucksformen.',
        faq3Question: 'Kann ich Google Imagen 4 kostenlos verwenden?',
        faq3Answer: 'Ja. Google Imagen 4 bietet begrenzte kostenlose Credits über die kostenlose Testversion von WeryAI an. Für umfangreiche Nutzung ist ein Upgrade erforderlich.',
        faq4Question: 'Welche Bildformate unterstützt Imagen?',
        faq4Answer: 'Imagen unterstützt verschiedene Bildformate, einschließlich JPG, PNG, WEBP und andere gängige Formate. Generierte Bilder zeichnen sich durch hohe Qualität und reichhaltige Details aus.',
        faq5Question: 'Kann ich Imagen für kommerzielle Projekte verwenden?',
        faq5Answer: 'Ja. Imagens hochpräzise Bildgenerierung und kreative Ausdrucksfähigkeiten machen es zu einer leistungsstarken Wahl für Designer, Künstler und Content-Ersteller, die hochwertige KI-generierte Bilder suchen.',
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription: 'Erleben Sie Imagen 4 jetzt und verwandeln Sie Ihre Ideen in erstaunliche Bilder',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    ru: {
        // Русский
        pageTitle: 'Генератор изображений ИИ Google Imagen 4 - Бесплатно текст в изображение',
        pageDescription: 'Google Imagen 4 - это мощная модель диффузии текста в изображение, разработанная для конкуренции с DALL-E от OpenAI. Создавайте изображения в различных стилях из простых текстовых описаний. От фотореалистичных до абстрактных, эта модель ИИ предоставляет детализированные результаты. Попробуйте Imagen 4 бесплатно на WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, генерация изображений ИИ, ИИ искусство, искусственный интеллект, редактирование изображений, творческое выражение, текст в изображение',
        ogTitle: 'Генератор изображений ИИ Google Imagen 4 - Бесплатно текст в изображение',
        ogDescription: 'Откройте для себя генератор изображений Google Imagen 4, мощную модель диффузии текста в изображение, разработанную Google.',
        twitterTitle: 'Генератор изображений ИИ Google Imagen 4 - Бесплатно текст в изображение',
        twitterDescription: 'Откройте для себя генератор изображений Google Imagen 4, мощную модель диффузии текста в изображение, разработанную Google.',
        generatorTitle: 'Генератор изображений Google Imagen 4',
        generatorSubtitle: 'WeryAI теперь глубоко интегрировал модель Imagen, Imagen 4 от Google - это мощная модель диффузии текста в изображение, разработанная для конкуренции с DALL-E от OpenAI. Создавайте изображения в различных стилях из простых текстовых описаний. От фотореалистичных до абстрактных, эта модель ИИ предоставляет детализированные результаты. Попробуйте Imagen 4 бесплатно на WeryAI!',
        coreFeaturesTitle: 'Основные функции Imagen',
        coreFeaturesSubtitle: 'Изучите основные функции генератора изображений Google Imagen 4 и отправьтесь в революционное путешествие по созданию изображений ИИ',
        accurateTextToImageTitle: 'Точная генерация текста в изображение',
        accurateTextToImageDesc: 'Создавайте высококачественные изображения, используя описательные текстовые промпты.',
        accurateTextToImageAlt: 'Пример точной генерации текста в изображение',
        advancedTextRenderingTitle: 'Расширенная визуализация текста',
        advancedTextRenderingDesc: 'Мощный анализ и следование текстовым промптам.',
        advancedTextRenderingAlt: 'Пример расширенной визуализации текста',
        diverseArtisticStylesTitle: 'Разнообразные художественные стили',
        diverseArtisticStylesDesc: 'Создавайте различные темы и стили с творческим талантом.',
        diverseArtisticStylesAlt: 'Пример разнообразных художественных стилей',
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Три простых шага для начала создания',
        step1Title: 'Выбрать модель',
        step1Description: 'Выберите модель Imagen в инструментах изображений ИИ',
        step2Title: 'Ввести контент',
        step2Description: 'Введите промпты или загрузите референсные изображения',
        step3Title: 'Сгенерировать изображение',
        step3Description: 'Нажмите кнопку генерации, подождите и скачайте ваше изображение',
        youtubeTitle: 'Видео YouTube о модели изображений Imagen 4',
        xPostsTitle: 'Публикации X о модели изображений Imagen 4',
        exploreModelsTitle: 'Изучите другие модели изображений ИИ на WeryAI',
        model1Title: 'Генератор изображений ИИ Google Nano Banana',
        model2Title: 'Генератор изображений ИИ FLUX',
        model3Title: 'Генератор изображений ИИ Qwen Image',
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Что такое Google Imagen 4?',
        faq1Answer: 'Imagen 4 от Google - это мощная модель диффузии текста в изображение, разработанная для конкуренции с DALL-E от OpenAI. Она может создавать изображения в различных стилях из простых текстовых описаний. От фотореалистичных до абстрактных, эта модель ИИ предоставляет детализированные результаты.',
        faq2Question: 'Какие преимущества имеет Imagen перед другими моделями генерации изображений?',
        faq2Answer: 'Imagen имеет значительные преимущества в качестве изображений, творческом выражении, контроле стиля и мультимодальном слиянии. Она может генерировать высококачественные изображения профессионального уровня и поддерживает сложное творческое выражение.',
        faq3Question: 'Могу ли я использовать Google Imagen 4 бесплатно?',
        faq3Answer: 'Да. Google Imagen 4 предлагает ограниченные бесплатные кредиты через бесплатную пробную версию WeryAI. Для расширенного использования требуется обновление.',
        faq4Question: 'Какие форматы изображений поддерживает Imagen?',
        faq4Answer: 'Imagen поддерживает различные форматы изображений, включая JPG, PNG, WEBP и другие распространенные форматы. Сгенерированные изображения отличаются высоким качеством и богатыми деталями.',
        faq5Question: 'Могу ли я использовать Imagen для коммерческих проектов?',
        faq5Answer: 'Да. Высокоточная генерация изображений и возможности творческого выражения Imagen делают его мощным выбором для дизайнеров, художников и создателей контента, ищущих высококачественные изображения, созданные ИИ.',
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription: 'Откройте для себя Imagen 4 сейчас и превратите ваши идеи в удивительные изображения',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    pt: {
        // Português
        pageTitle: 'Gerador de Imagens IA Google Imagen 4 - Texto para Imagem Grátis',
        pageDescription: 'Google Imagen 4 é um poderoso modelo de difusão de texto para imagem projetado para competir com DALL-E da OpenAI. Gere imagens em vários estilos a partir de descrições de texto simples. Do fotorrealista ao abstrato, este modelo IA oferece resultados detalhados. Experimente Imagen 4 gratuitamente no WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, geração de imagens IA, arte IA, inteligência artificial, edição de imagens, expressão criativa, texto para imagem',
        ogTitle: 'Gerador de Imagens IA Google Imagen 4 - Texto para Imagem Grátis',
        ogDescription: 'Experimente o gerador de imagens Google Imagen 4, um poderoso modelo de difusão de texto para imagem desenvolvido pelo Google.',
        twitterTitle: 'Gerador de Imagens IA Google Imagen 4 - Texto para Imagem Grátis',
        twitterDescription: 'Experimente o gerador de imagens Google Imagen 4, um poderoso modelo de difusão de texto para imagem desenvolvido pelo Google.',
        generatorTitle: 'Gerador de Imagens Google Imagen 4',
        generatorSubtitle: 'O WeryAI agora integra profundamente o modelo Imagen, Imagen 4 do Google é um poderoso modelo de difusão de texto para imagem projetado para competir com DALL-E da OpenAI. Gere imagens em vários estilos a partir de descrições de texto simples. Do fotorrealista ao abstrato, este modelo IA oferece resultados detalhados. Experimente Imagen 4 gratuitamente no WeryAI!',
        coreFeaturesTitle: 'Recursos Principais do Imagen',
        coreFeaturesSubtitle: 'Explore os recursos principais do gerador de imagens Google Imagen 4 e embarque em uma jornada revolucionária de criação de imagens IA',
        accurateTextToImageTitle: 'Geração Precisa de Texto para Imagem',
        accurateTextToImageDesc: 'Gere imagens de alta qualidade usando prompts de texto descritivos.',
        accurateTextToImageAlt: 'Exemplo de Geração Precisa de Texto para Imagem',
        advancedTextRenderingTitle: 'Renderização de Texto Avançada',
        advancedTextRenderingDesc: 'Análise e seguimento poderosos de prompts de texto.',
        advancedTextRenderingAlt: 'Exemplo de Renderização de Texto Avançada',
        diverseArtisticStylesTitle: 'Estilos Artísticos Diversos',
        diverseArtisticStylesDesc: 'Crie vários temas e estilos com talento criativo.',
        diverseArtisticStylesAlt: 'Exemplo de Estilos Artísticos Diversos',
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar a criar',
        step1Title: 'Selecionar Modelo',
        step1Description: 'Escolha o modelo Imagen em ferramentas de imagem IA',
        step2Title: 'Inserir Conteúdo',
        step2Description: 'Digite prompts ou carregue imagens de referência',
        step3Title: 'Gerar Imagem',
        step3Description: 'Clique no botão gerar, aguarde e baixe sua imagem',
        youtubeTitle: 'Vídeos do YouTube Sobre o Modelo de Imagem Imagen 4',
        xPostsTitle: 'Publicações X Sobre o Modelo de Imagem Imagen 4',
        exploreModelsTitle: 'Explore Outros Modelos de Imagem IA no WeryAI',
        model1Title: 'Gerador de Imagens IA Google Nano Banana',
        model2Title: 'Gerador de Imagens IA FLUX',
        model3Title: 'Gerador de Imagens IA Qwen Image',
        faqTitle: 'Perguntas Frequentes',
        faq1Question: 'O que é Google Imagen 4?',
        faq1Answer: 'Imagen 4 do Google é um poderoso modelo de difusão de texto para imagem projetado para competir com DALL-E da OpenAI. Pode gerar imagens em vários estilos a partir de descrições de texto simples. Do fotorrealista ao abstrato, este modelo IA oferece resultados detalhados.',
        faq2Question: 'Quais vantagens o Imagen tem sobre outros modelos de geração de imagens?',
        faq2Answer: 'Imagen tem vantagens significativas em qualidade de imagem, expressão criativa, controle de estilo e fusão multimodal. Pode gerar imagens de nível profissional de alta qualidade e suporta expressão criativa complexa.',
        faq3Question: 'Posso usar o Google Imagen 4 gratuitamente?',
        faq3Answer: 'Sim. Google Imagen 4 oferece créditos gratuitos limitados através do teste gratuito do WeryAI. Para uso extensivo, é necessário um upgrade.',
        faq4Question: 'Quais formatos de imagem o Imagen suporta?',
        faq4Answer: 'Imagen suporta vários formatos de imagem, incluindo JPG, PNG, WEBP e outros formatos comuns. As imagens geradas apresentam alta qualidade e detalhes ricos.',
        faq5Question: 'Posso usar o Imagen para projetos comerciais?',
        faq5Answer: 'Sim. As capacidades de geração de imagens de alta precisão e expressão criativa do Imagen o tornam uma escolha poderosa para designers, artistas e criadores de conteúdo que buscam imagens geradas por IA de alta qualidade.',
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o Imagen 4 agora e transforme suas ideias em imagens incríveis',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    it: {
        // Italiano
        pageTitle: 'Generatore di Immagini IA Google Imagen 4 - Testo a Immagine Gratis',
        pageDescription: 'Google Imagen 4 è un potente modello di diffusione testo-immagine progettato per competere con DALL-E di OpenAI. Genera immagini in vari stili da semplici descrizioni testuali. Dal fotorealistico all\'astratto, questo modello IA fornisce risultati dettagliati. Prova Imagen 4 gratuitamente su WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, generazione di immagini IA, arte IA, intelligenza artificiale, modifica di immagini, espressione creativa, testo a immagine',
        ogTitle: 'Generatore di Immagini IA Google Imagen 4 - Testo a Immagine Gratis',
        ogDescription: 'Scopri il generatore di immagini Google Imagen 4, un potente modello di diffusione testo-immagine sviluppato da Google.',
        twitterTitle: 'Generatore di Immagini IA Google Imagen 4 - Testo a Immagine Gratis',
        twitterDescription: 'Scopri il generatore di immagini Google Imagen 4, un potente modello di diffusione testo-immagine sviluppato da Google.',
        generatorTitle: 'Generatore di Immagini Google Imagen 4',
        generatorSubtitle: 'WeryAI integra ora in profondità il modello Imagen, Imagen 4 di Google è un potente modello di diffusione testo-immagine progettato per competere con DALL-E di OpenAI. Genera immagini in vari stili da semplici descrizioni testuali. Dal fotorealistico all\'astratto, questo modello IA fornisce risultati dettagliati. Prova Imagen 4 gratuitamente su WeryAI!',
        coreFeaturesTitle: 'Caratteristiche Principali di Imagen',
        coreFeaturesSubtitle: 'Esplora le caratteristiche principali del generatore di immagini Google Imagen 4 e intraprendi un viaggio rivoluzionario nella creazione di immagini IA',
        accurateTextToImageTitle: 'Generazione Precisa da Testo a Immagine',
        accurateTextToImageDesc: 'Genera immagini di alta qualità usando prompt di testo descrittivi.',
        accurateTextToImageAlt: 'Esempio di Generazione Precisa da Testo a Immagine',
        advancedTextRenderingTitle: 'Rendering di Testo Avanzato',
        advancedTextRenderingDesc: 'Analisi e seguimento potenti dei prompt di testo.',
        advancedTextRenderingAlt: 'Esempio di Rendering di Testo Avanzato',
        diverseArtisticStylesTitle: 'Stili Artistici Diversi',
        diverseArtisticStylesDesc: 'Crea vari temi e stili con talento creativo.',
        diverseArtisticStylesAlt: 'Esempio di Stili Artistici Diversi',
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi per iniziare a creare',
        step1Title: 'Seleziona Modello',
        step1Description: 'Scegli il modello Imagen negli strumenti di immagine IA',
        step2Title: 'Inserisci Contenuto',
        step2Description: 'Inserisci prompt o carica immagini di riferimento',
        step3Title: 'Genera Immagine',
        step3Description: 'Fai clic sul pulsante genera, attendi e scarica la tua immagine',
        youtubeTitle: 'Video YouTube Sul Modello di Immagine Imagen 4',
        xPostsTitle: 'Post X Sul Modello di Immagine Imagen 4',
        exploreModelsTitle: 'Esplora Altri Modelli di Immagine IA su WeryAI',
        model1Title: 'Generatore di Immagini IA Google Nano Banana',
        model2Title: 'Generatore di Immagini IA FLUX',
        model3Title: 'Generatore di Immagini IA Qwen Image',
        faqTitle: 'Domande Frequenti',
        faq1Question: 'Cos\'è Google Imagen 4?',
        faq1Answer: 'Imagen 4 di Google è un potente modello di diffusione testo-immagine progettato per competere con DALL-E di OpenAI. Può generare immagini in vari stili da semplici descrizioni testuali. Dal fotorealistico all\'astratto, questo modello IA fornisce risultati dettagliati.',
        faq2Question: 'Quali vantaggi ha Imagen rispetto ad altri modelli di generazione di immagini?',
        faq2Answer: 'Imagen ha vantaggi significativi in qualità dell\'immagine, espressione creativa, controllo dello stile e fusione multimodale. Può generare immagini di livello professionale di alta qualità e supporta espressione creativa complessa.',
        faq3Question: 'Posso usare Google Imagen 4 gratuitamente?',
        faq3Answer: 'Sì. Google Imagen 4 offre crediti gratuiti limitati attraverso la prova gratuita di WeryAI. Per un uso estensivo, è richiesto un upgrade.',
        faq4Question: 'Quali formati di immagine supporta Imagen?',
        faq4Answer: 'Imagen supporta vari formati di immagine tra cui JPG, PNG, WEBP e altri formati comuni. Le immagini generate presentano alta qualità e dettagli ricchi.',
        faq5Question: 'Posso usare Imagen per progetti commerciali?',
        faq5Answer: 'Sì. Le capacità di generazione di immagini ad alta precisione e di espressione creativa di Imagen lo rendono una scelta potente per designer, artisti e creatori di contenuti che cercano immagini generate da IA di alta qualità.',
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription: 'Prova Imagen 4 ora e trasforma le tue idee in immagini straordinarie',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    ar: {
        // العربية
        pageTitle: 'مولد صور الذكاء الاصطناعي Google Imagen 4 - نص إلى صورة مجاني',
        pageDescription: 'Google Imagen 4 هو نموذج انتشار نص إلى صورة قوي مصمم للتنافس مع DALL-E من OpenAI. أنشئ صورًا بأنماط مختلفة من أوصاف نصية بسيطة. من الواقعية الفوتوغرافية إلى التجريدية، يقدم نموذج الذكاء الاصطناعي هذا نتائج مفصلة. جرب Imagen 4 مجانًا على WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, توليد صور الذكاء الاصطناعي, فن الذكاء الاصطناعي, الذكاء الاصطناعي, تحرير الصور, التعبير الإبداعي, نص إلى صورة',
        ogTitle: 'مولد صور الذكاء الاصطناعي Google Imagen 4 - نص إلى صورة مجاني',
        ogDescription: 'اكتشف مولد صور Google Imagen 4، نموذج انتشار نص إلى صورة قوي تم تطويره بواسطة Google.',
        twitterTitle: 'مولد صور الذكاء الاصطناعي Google Imagen 4 - نص إلى صورة مجاني',
        twitterDescription: 'اكتشف مولد صور Google Imagen 4، نموذج انتشار نص إلى صورة قوي تم تطويره بواسطة Google.',
        generatorTitle: 'مولد صور Google Imagen 4',
        generatorSubtitle: 'يقوم WeryAI الآن بدمج نموذج Imagen بعمق، Imagen 4 من Google هو نموذج انتشار نص إلى صورة قوي مصمم للتنافس مع DALL-E من OpenAI. أنشئ صورًا بأنماط مختلفة من أوصاف نصية بسيطة. من الواقعية الفوتوغرافية إلى التجريدية، يقدم نموذج الذكاء الاصطناعي هذا نتائج مفصلة. جرب Imagen 4 مجانًا على WeryAI!',
        coreFeaturesTitle: 'الميزات الأساسية لـ Imagen',
        coreFeaturesSubtitle: 'استكشف الميزات الأساسية لمولد صور Google Imagen 4 وانطلق في رحلة ثورية لإنشاء صور الذكاء الاصطناعي',
        accurateTextToImageTitle: 'توليد دقيق من النص إلى الصورة',
        accurateTextToImageDesc: 'أنشئ صورًا عالية الجودة باستخدام مطالبات نصية وصفية.',
        accurateTextToImageAlt: 'مثال على التوليد الدقيق من النص إلى الصورة',
        advancedTextRenderingTitle: 'عرض نص متقدم',
        advancedTextRenderingDesc: 'تحليل ومتابعة قويان لمطالبات النص.',
        advancedTextRenderingAlt: 'مثال على عرض النص المتقدم',
        diverseArtisticStylesTitle: 'أنماط فنية متنوعة',
        diverseArtisticStylesDesc: 'أنشئ موضوعات وأنماط مختلفة بموهبة إبداعية.',
        diverseArtisticStylesAlt: 'مثال على الأنماط الفنية المتنوعة',
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة للبدء في الإنشاء',
        step1Title: 'اختر النموذج',
        step1Description: 'اختر نموذج Imagen في أدوات صور الذكاء الاصطناعي',
        step2Title: 'أدخل المحتوى',
        step2Description: 'أدخل المطالبات أو قم بتحميل صور مرجعية',
        step3Title: 'إنشاء الصورة',
        step3Description: 'انقر فوق زر الإنشاء، وانتظر وقم بتنزيل صورتك',
        youtubeTitle: 'مقاطع فيديو يوتيوب حول نموذج صور Imagen 4',
        xPostsTitle: 'منشورات X حول نموذج صور Imagen 4',
        exploreModelsTitle: 'استكشف نماذج صور الذكاء الاصطناعي الأخرى على WeryAI',
        model1Title: 'مولد صور الذكاء الاصطناعي Google Nano Banana',
        model2Title: 'مولد صور الذكاء الاصطناعي FLUX',
        model3Title: 'مولد صور الذكاء الاصطناعي Qwen Image',
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هو Google Imagen 4؟',
        faq1Answer: 'Imagen 4 من Google هو نموذج انتشار نص إلى صورة قوي مصمم للتنافس مع DALL-E من OpenAI. يمكنه إنشاء صور بأنماط مختلفة من أوصاف نصية بسيطة. من الواقعية الفوتوغرافية إلى التجريدية، يقدم نموذج الذكاء الاصطناعي هذا نتائج مفصلة.',
        faq2Question: 'ما هي المزايا التي يتمتع بها Imagen مقارنة بنماذج توليد الصور الأخرى؟',
        faq2Answer: 'يتمتع Imagen بمزايا كبيرة في جودة الصورة والتعبير الإبداعي والتحكم في الأسلوب والدمج متعدد الوسائط. يمكنه توليد صور بمستوى احترافي عالية الجودة ويدعم التعبير الإبداعي المعقد.',
        faq3Question: 'هل يمكنني استخدام Google Imagen 4 مجانًا؟',
        faq3Answer: 'نعم. يقدم Google Imagen 4 أرصدة مجانية محدودة من خلال الإصدار التجريبي المجاني من WeryAI. للاستخدام المكثف، يلزم الترقية.',
        faq4Question: 'ما تنسيقات الصور التي يدعمها Imagen؟',
        faq4Answer: 'يدعم Imagen تنسيقات صور مختلفة بما في ذلك JPG وPNG وWEBP وتنسيقات شائعة أخرى. تتميز الصور المُنشأة بجودة عالية وتفاصيل غنية.',
        faq5Question: 'هل يمكنني استخدام Imagen للمشاريع التجارية؟',
        faq5Answer: 'نعم. تجعل قدرات توليد الصور عالية الدقة والتعبير الإبداعي في Imagen منه خيارًا قويًا للمصممين والفنانين ومنشئي المحتوى الذين يبحثون عن صور عالية الجودة منشأة بالذكاء الاصطناعي.',
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription: 'جرب Imagen 4 الآن وحول أفكارك إلى صور مذهلة',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    th: { // Thai (copied from English)
        // SEO Meta
        pageTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        pageDescription: 'Google Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI DALL-E. Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        ogDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Twitter Card
        twitterTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        twitterDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Generator Section
        generatorTitle: 'Google Imagen 4 Image Generator',
        generatorSubtitle: 'ขณะนี้ WeryAI ได้ผสานรวมโมเดล Imagen อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล Imagen อย่างลึกซึ้งแล้ว Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',

        // Core Features Section
        coreFeaturesTitle: 'Imagen Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Google Imagen 4 image generator and embark on a revolutionary AI image creation journey',

        // Features
        accurateTextToImageTitle: 'Accurate Text-to-Image Generation',
        accurateTextToImageDesc: 'Generate high-quality images using descriptive text prompts.',
        accurateTextToImageAlt: 'Accurate Text-to-Image Generation Example',

        advancedTextRenderingTitle: 'Advanced Text Rendering',
        advancedTextRenderingDesc: 'Powerful text prompt analysis and following.',
        advancedTextRenderingAlt: 'Advanced Text Rendering Example',

        diverseArtisticStylesTitle: 'Diverse Artistic Styles',
        diverseArtisticStylesDesc: 'Create various themes and styles with creative flair.',
        diverseArtisticStylesAlt: 'Diverse Artistic Styles Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Imagen model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Imagen 4 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Imagen 4 Image Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Imagen 4?',
        faq1Answer: 'Google\'s Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI\'s DALL-E. It can generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs.',

        faq2Question: 'What advantages does Imagen have over other image generation models?',
        faq2Answer: 'Imagen has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',

        faq3Question: 'Can I use Google Imagen 4 for free?',
        faq3Answer: 'Yes. Google Imagen 4 offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',

        faq4Question: 'What image formats does Imagen support?',
        faq4Answer: 'Imagen supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Imagen for commercial projects?',
        faq5Answer: 'Yes. Imagen\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Imagen 4 now and transform your ideas into amazing images',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    da: { // Danish (copied from English)
        // SEO Meta
        pageTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        pageDescription: 'Google Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI DALL-E. Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        ogDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Twitter Card
        twitterTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        twitterDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Generator Section
        generatorTitle: 'Google Imagen 4 Image Generator',
        generatorSubtitle: 'WeryAI har nu integreret modellen Imagen i dybden, Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',

        // Core Features Section
        coreFeaturesTitle: 'Imagen Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Google Imagen 4 image generator and embark on a revolutionary AI image creation journey',

        // Features
        accurateTextToImageTitle: 'Accurate Text-to-Image Generation',
        accurateTextToImageDesc: 'Generate high-quality images using descriptive text prompts.',
        accurateTextToImageAlt: 'Accurate Text-to-Image Generation Example',

        advancedTextRenderingTitle: 'Advanced Text Rendering',
        advancedTextRenderingDesc: 'Powerful text prompt analysis and following.',
        advancedTextRenderingAlt: 'Advanced Text Rendering Example',

        diverseArtisticStylesTitle: 'Diverse Artistic Styles',
        diverseArtisticStylesDesc: 'Create various themes and styles with creative flair.',
        diverseArtisticStylesAlt: 'Diverse Artistic Styles Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Imagen model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Imagen 4 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Imagen 4 Image Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Imagen 4?',
        faq1Answer: 'Google\'s Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI\'s DALL-E. It can generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs.',

        faq2Question: 'What advantages does Imagen have over other image generation models?',
        faq2Answer: 'Imagen has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',

        faq3Question: 'Can I use Google Imagen 4 for free?',
        faq3Answer: 'Yes. Google Imagen 4 offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',

        faq4Question: 'What image formats does Imagen support?',
        faq4Answer: 'Imagen supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Imagen for commercial projects?',
        faq5Answer: 'Yes. Imagen\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Imagen 4 now and transform your ideas into amazing images',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    no: { // Norwegian (copied from English)
        // SEO Meta
        pageTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        pageDescription: 'Google Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI DALL-E. Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        ogDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Twitter Card
        twitterTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        twitterDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Generator Section
        generatorTitle: 'Google Imagen 4 Image Generator',
        generatorSubtitle: 'WeryAI har nå integrert modellen Imagen i dybden, Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',

        // Core Features Section
        coreFeaturesTitle: 'Imagen Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Google Imagen 4 image generator and embark on a revolutionary AI image creation journey',

        // Features
        accurateTextToImageTitle: 'Accurate Text-to-Image Generation',
        accurateTextToImageDesc: 'Generate high-quality images using descriptive text prompts.',
        accurateTextToImageAlt: 'Accurate Text-to-Image Generation Example',

        advancedTextRenderingTitle: 'Advanced Text Rendering',
        advancedTextRenderingDesc: 'Powerful text prompt analysis and following.',
        advancedTextRenderingAlt: 'Advanced Text Rendering Example',

        diverseArtisticStylesTitle: 'Diverse Artistic Styles',
        diverseArtisticStylesDesc: 'Create various themes and styles with creative flair.',
        diverseArtisticStylesAlt: 'Diverse Artistic Styles Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Imagen model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Imagen 4 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Imagen 4 Image Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Imagen 4?',
        faq1Answer: 'Google\'s Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI\'s DALL-E. It can generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs.',

        faq2Question: 'What advantages does Imagen have over other image generation models?',
        faq2Answer: 'Imagen has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',

        faq3Question: 'Can I use Google Imagen 4 for free?',
        faq3Answer: 'Yes. Google Imagen 4 offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',

        faq4Question: 'What image formats does Imagen support?',
        faq4Answer: 'Imagen supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Imagen for commercial projects?',
        faq5Answer: 'Yes. Imagen\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Imagen 4 now and transform your ideas into amazing images',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    nl: { // Dutch (copied from English)
        // SEO Meta
        pageTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        pageDescription: 'Google Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI DALL-E. Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        ogDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Twitter Card
        twitterTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        twitterDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Generator Section
        generatorTitle: 'Google Imagen 4 Image Generator',
        generatorSubtitle: 'WeryAI heeft het model Imagen nu diep geïntegreerd, Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',

        // Core Features Section
        coreFeaturesTitle: 'Imagen Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Google Imagen 4 image generator and embark on a revolutionary AI image creation journey',

        // Features
        accurateTextToImageTitle: 'Accurate Text-to-Image Generation',
        accurateTextToImageDesc: 'Generate high-quality images using descriptive text prompts.',
        accurateTextToImageAlt: 'Accurate Text-to-Image Generation Example',

        advancedTextRenderingTitle: 'Advanced Text Rendering',
        advancedTextRenderingDesc: 'Powerful text prompt analysis and following.',
        advancedTextRenderingAlt: 'Advanced Text Rendering Example',

        diverseArtisticStylesTitle: 'Diverse Artistic Styles',
        diverseArtisticStylesDesc: 'Create various themes and styles with creative flair.',
        diverseArtisticStylesAlt: 'Diverse Artistic Styles Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Imagen model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Imagen 4 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Imagen 4 Image Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Imagen 4?',
        faq1Answer: 'Google\'s Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI\'s DALL-E. It can generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs.',

        faq2Question: 'What advantages does Imagen have over other image generation models?',
        faq2Answer: 'Imagen has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',

        faq3Question: 'Can I use Google Imagen 4 for free?',
        faq3Answer: 'Yes. Google Imagen 4 offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',

        faq4Question: 'What image formats does Imagen support?',
        faq4Answer: 'Imagen supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Imagen for commercial projects?',
        faq5Answer: 'Yes. Imagen\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Imagen 4 now and transform your ideas into amazing images',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    id: { // Indonesian (copied from English)
        // SEO Meta
        pageTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        pageDescription: 'Google Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI DALL-E. Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        ogDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Twitter Card
        twitterTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        twitterDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Generator Section
        generatorTitle: 'Google Imagen 4 Image Generator',
        generatorSubtitle: 'WeryAI kini telah mengintegrasikan model Imagen secara mendalam, Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',

        // Core Features Section
        coreFeaturesTitle: 'Imagen Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Google Imagen 4 image generator and embark on a revolutionary AI image creation journey',

        // Features
        accurateTextToImageTitle: 'Accurate Text-to-Image Generation',
        accurateTextToImageDesc: 'Generate high-quality images using descriptive text prompts.',
        accurateTextToImageAlt: 'Accurate Text-to-Image Generation Example',

        advancedTextRenderingTitle: 'Advanced Text Rendering',
        advancedTextRenderingDesc: 'Powerful text prompt analysis and following.',
        advancedTextRenderingAlt: 'Advanced Text Rendering Example',

        diverseArtisticStylesTitle: 'Diverse Artistic Styles',
        diverseArtisticStylesDesc: 'Create various themes and styles with creative flair.',
        diverseArtisticStylesAlt: 'Diverse Artistic Styles Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Imagen model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Imagen 4 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Imagen 4 Image Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Imagen 4?',
        faq1Answer: 'Google\'s Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI\'s DALL-E. It can generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs.',

        faq2Question: 'What advantages does Imagen have over other image generation models?',
        faq2Answer: 'Imagen has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',

        faq3Question: 'Can I use Google Imagen 4 for free?',
        faq3Answer: 'Yes. Google Imagen 4 offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',

        faq4Question: 'What image formats does Imagen support?',
        faq4Answer: 'Imagen supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Imagen for commercial projects?',
        faq5Answer: 'Yes. Imagen\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Imagen 4 now and transform your ideas into amazing images',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    tr: { // Turkish (copied from English)
        // SEO Meta
        pageTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        pageDescription: 'Google Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI DALL-E. Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',
        pageKeywords: 'Imagen 4, Google AI, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        ogDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Twitter Card
        twitterTitle: 'Google Imagen 4 AI Image Generator - Free Text to Image',
        twitterDescription: 'Experience Google Imagen 4 image generator, a powerful text-to-image diffusion model developed by Google.',

        // Generator Section
        generatorTitle: 'Google Imagen 4 Image Generator',
        generatorSubtitle: 'WeryAI artık Imagen modelini derinlemesine entegre ediyor, Generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs. Try Imagen 4 for free on WeryAI!',

        // Core Features Section
        coreFeaturesTitle: 'Imagen Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Google Imagen 4 image generator and embark on a revolutionary AI image creation journey',

        // Features
        accurateTextToImageTitle: 'Accurate Text-to-Image Generation',
        accurateTextToImageDesc: 'Generate high-quality images using descriptive text prompts.',
        accurateTextToImageAlt: 'Accurate Text-to-Image Generation Example',

        advancedTextRenderingTitle: 'Advanced Text Rendering',
        advancedTextRenderingDesc: 'Powerful text prompt analysis and following.',
        advancedTextRenderingAlt: 'Advanced Text Rendering Example',

        diverseArtisticStylesTitle: 'Diverse Artistic Styles',
        diverseArtisticStylesDesc: 'Create various themes and styles with creative flair.',
        diverseArtisticStylesAlt: 'Diverse Artistic Styles Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Imagen model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Imagen 4 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Imagen 4 Image Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Imagen 4?',
        faq1Answer: 'Google\'s Imagen 4 is a powerful text-to-image diffusion model designed to compete with OpenAI\'s DALL-E. It can generate images in various styles from simple text descriptions. From photorealistic to abstract, this AI model delivers detailed outputs.',

        faq2Question: 'What advantages does Imagen have over other image generation models?',
        faq2Answer: 'Imagen has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',

        faq3Question: 'Can I use Google Imagen 4 for free?',
        faq3Answer: 'Yes. Google Imagen 4 offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',

        faq4Question: 'What image formats does Imagen support?',
        faq4Answer: 'Imagen supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Imagen for commercial projects?',
        faq5Answer: 'Yes. Imagen\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Imagen 4 now and transform your ideas into amazing images',
        ctaButton: 'Try Imagen on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
}
